<h1>Textured geometric objects</h1>
<canvas #canvasDocument class="canvas"></canvas>
<footer class="footer">
  <div class="footer__fps">{{ fps }}</div>
  <div class="footer__button-group">
    <p class="footer__label">Geometry object type:</p>
    <button
      class="footer__button"
      *ngFor="let objectType of objectTypes"
      (tap)="selectObject(objectType)"
      [class.is-active]="selectedObjectType === objectType"
    >
      {{ objectType }}
    </button>
  </div>
</footer>
